module.exports = __webpack_public_path__ + "img/appAsset-brand--khipu.dca9b17c.svg";